import fetchNotifications from './fetchNotifications'
import { deleteNotifications } from './deleteNotifications'
import { markNotificationsRead } from './markAsRead'
import { markNotificationsSeen } from './markAsSeen'

enum NotificationType {
  BookingImport = 'Notifications_Notification_Reservations',
  ICalImport = 'Notifications_Notification_IcalImport',
  ICalExport = 'Notifications_Notification_IcalExport',
  ReservationIssues = 'Notifications_Notification_ReservationIssue',
  ICalReservationIssues = 'Notifications_Notification_IcalReservationIssue',
  BookingSynchronization = 'Notifications_Notification_Synchronization',
  NotificationError = 'Notifications_Notification_Error',
  PropertyCreate = 'Notifications_Notification_PropertyCreate',
  PropertyDelete = 'Notifications_Notification_PropertyDelete',
  PropertyEdit = 'Notifications_Notification_PropertyEdit',
  ICalUrlIssue = 'Notifications_Notification_IcalUrlIssue',
  ICalLicenseExtended = 'Notifications_Notification_IcalLicenseExtended',
  BookingLicenseExtended = 'Notifications_Notification_LicenseExtended',
  ICalLicenseRenewed = 'Notifications_Notification_IcalLicenseRenewed',
  ICalLicenseExpired = 'Notifications_Notification_IcalLicenseExpired',
  BookingLicenseExpired = 'Notifications_Notification_LicenseExpired',
  BookingLicenseRenewed = 'Notifications_Notification_LicenseRenewed',
  AirbnbImport = 'Notifications_Notification_AirbnbImport',
  AirbnbExport = 'Notifications_Notification_AirbnbExport',
  AirbnbExportError = 'Notifications_Notification_AirbnbExportError',
  AirbnbError = 'Notifications_Notification_AirbnbError',
}

export {
  fetchNotifications,
  deleteNotifications,
  markNotificationsRead,
  markNotificationsSeen,
  NotificationType,
}
